import { discountTypes } from "@ac-expo/api-types";
import { DiscountType } from "@prisma/client";
import { DefaultValues } from "react-hook-form";
import { z } from "zod";

export const createDiscountSchema = z
  .object({
    id: z.string().optional(),
    type: z.enum(discountTypes as [DiscountType, ...DiscountType[]]),
    value: z.coerce
      .number({ invalid_type_error: "La réduction est requise" })
      .gt(0, "Le réduction doit être supérieur à 0"),
  })
  .refine(({ type, value }) => type !== "percentage" || value <= 100, {
    message: "La réduction ne peut pas être supérieure à 100%",
    path: ["value"],
  });

export type CreateDiscount = z.infer<typeof createDiscountSchema>;

export const defaultCreateDiscountValues: DefaultValues<CreateDiscount> = {
  type: DiscountType.percentage,
  value: undefined,
};
